import React, { FunctionComponent, useEffect, useMemo, useRef, useState } from "react";
import { Country } from "@Types/cart";
import CartCountriesListItem from "./CartCountriesListItem";
import "./style.scss";

interface Props {
  countries: Country[];
  onSelect: (country: Country) => void;
  parentPos: DOMRect;
  selectedCountry: string | undefined;
}

const CartCountriesList: FunctionComponent<Props> = ({
  countries,
  onSelect,
  parentPos,
  selectedCountry,
}) => {
  const menuContainerRef = useRef<HTMLDivElement>(null);
  const [parentTop, setParentTop] = useState<number>(parentPos ? parentPos.top : 0);
  const selectedIndex = useMemo(
    () => countries.findIndex((value) => value.tag === selectedCountry),
    [countries, selectedCountry]
  );

  useEffect(() => {
    if (parentPos && menuContainerRef.current) {
      const containerPos = menuContainerRef.current.getBoundingClientRect();
      const optionsVisibleCount = countries.length >= 5 ? 5 : countries.length;

      const top = ((index) => {
        switch (index) {
          case 0:
            return parentPos.top - parentPos.height / 2;
          case 1:
            return parentPos.top - parentPos.height / 2 - containerPos.height / optionsVisibleCount;
          case countries.length - 2:
            return (
              parentPos.top -
              (containerPos.height / optionsVisibleCount) * (optionsVisibleCount - 2) -
              parentPos.height / 2
            );
          case countries.length - 1:
            return (
              parentPos.top -
              (containerPos.height / optionsVisibleCount) * (optionsVisibleCount - 1) -
              parentPos.height / 2
            );
          default:
            return (
              parentPos.top - parentPos.height / 2 - containerPos.height / (optionsVisibleCount / 2)
            );
        }
      })(selectedIndex);

      setParentTop(top);
    }
  }, [countries, parentPos, selectedIndex]);

  return (
    <div
      className="CartCountriesList"
      style={{ left: parentPos ? parentPos.left : 0, top: parentTop }}
      ref={menuContainerRef}
    >
      <ul className="CartCountriesList-item">
        {countries.map((country) => {
          return (
            <CartCountriesListItem
              country={country}
              key={country.tagAlpha3}
              onMouseUp={onSelect}
              selected={selectedCountry === country.name}
            />
          );
        })}
      </ul>
    </div>
  );
};

export default CartCountriesList;
